import { render, staticRenderFns } from "./APIDemo.vue?vue&type=template&id=da10385e&"
import script from "./APIDemo.vue?vue&type=script&lang=js&"
export * from "./APIDemo.vue?vue&type=script&lang=js&"
import style0 from "./APIDemo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "APIDemo.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/APIDemo.vue
// module id = null
// module chunks = 